export const tableHeadConfig = [
  { id: 1, label: 'DR-Code', isSortable: true, parameter: 'drCode', styleName: 'assetHead' },
  { id: 2, label: 'Sublocations', isSortable: true, parameter: 'lastLocationHistory.sublocation.name', styleName: 'sublocationHead' },
  { id: 3, label: 'Status', isSortable: false, styleName: 'statusHead' },
  { id: 4, label: 'Rental', isSortable: true, parameter: 'rental.rentalStatus.name', styleName: 'rentalHead' },
  { id: 5, label: 'Last Verified', isSortable: true, parameter: 'LastVerificationDateAtUtc', styleName: 'lastVerifiedHead' },
  { id: 6, label: 'Verified by', isSortable: true, parameter: 'LastVerificationBy', styleName: 'verifiedByHead' },
  { id: 7, label: 'Short Note', isSortable: true, parameter: 'shortNote', styleName: 'noteHead' }
];
